export default __webpack_public_path__ + "static/media/winline_loyalty_2.4ea7d88b.png";